import React from "react";
import { View, StyleSheet } from "react-native";
import NtCaseStudySectionContainer from "./NtCaseStudySectionContainer";
import NtMaterialIcon from "../../../components/NtMaterialIcon";
import NtCaseStudyText from "./NtCaseStudyText";

function NtCaseStudyNotFound({}) {
  return (
    <NtCaseStudySectionContainer containerStyle={styles.container}>
      <View
        style={{ marginTop: -100, flexDirection: "row", alignItems: "center" }}
      >
        <NtMaterialIcon name="traffic-cone" size={30} color={"white"} />
        <NtCaseStudyText
          style={{ fontWeight: "700", fontSize: 20, marginLeft: 20 }}
        >
          Invalid Case Study
        </NtCaseStudyText>
      </View>
    </NtCaseStudySectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    height: window.innerHeight - 200,
    alignItems: "center",
    justifyContent: "center",
  },
});

export default NtCaseStudyNotFound;
